import React, { useContext,} from 'react'
import { createPortal } from 'react-dom'

import imageTransferArgent from '../../assets/imageTransferArgent.svg'
import imageRechargeMobile from '../../assets/imageRechargeMobile.svg'
import imageTransferWalletSenegal from '../../assets/imageTransferWallet.svg'
import imageTransferBancaire from '../../assets/imageTransferBancaire.svg'
import imagePaimentFacture from '../../assets/imagePaimentFacture.svg'
import iconCloseModalRecharge from '../../assets/iconCloseModalRecharge.svg'
import BGModal from  '../../assets/modalBG.svg'

import { useNavigate } from 'react-router-dom'
import Avatar from 'components/avatar'
import transferBeneficiaryContext from 'contexts/transferBeneficiaryContext'

interface Props {
  nom: any
  num: any
  photo: any
  index?: any
  indexBeneficiary?: any
  isOpen: boolean
  person: any
  prefix : any
  closeModal: () => void
}

const ListFunction = [
  {
    icon: imageTransferArgent,
    transaction : "Transfert avec retrait cash",
    color : 'bg-[#4743C9]',
    navigate: '/transfert/0',
    Enabled: ['TND', 'MAD','PKR', 'BDT']
  },
  {
    icon: imageTransferBancaire,
    transaction : "Transfert de compte à compte ",
    color : 'bg-[#20C374]',
    navigate: '/transfert/1',
    Enabled: ['TND', 'MAD','PKR','TRY','NGN','XOF','PHP', 'KES']

  },
  {
    icon: imageRechargeMobile,
    transaction : "Recharge mobile",
    color : 'bg-[#FFC000]',
    navigate: '/recharge',
    Enabled:['all']

  },
   {
    icon: imageTransferWalletSenegal,
    transaction : "Transfert vers Wallet",
    color : 'bg-[#B28858]',
    navigate: '/transfert-vers-wallet',
    Enabled: ['XOF', 'XOF', 'KES', 'PHP', 'PKR']

  },
  {
    icon: imagePaimentFacture,

    transaction : "Paiement de factures locales",
    color : 'bg-[#38C3FF]',
    navigate: '/paimentFacture',

  }
]

const ModalHomeBeneficiary: React.FC<Props> = ({
  isOpen,
  closeModal,
  nom,
  num,
  photo,
  index,
  indexBeneficiary,
  person,
  prefix,
  
}) => {
  const modalRoot = document.getElementById('modal-root')

  if (!isOpen || !modalRoot) return null

  const navigate = useNavigate()
  const { TransferData } = useContext(transferBeneficiaryContext)

  return createPortal(
      <div className='fixed flex flex-col justify-center place-items-center inset-0 z-50 isolate bg-[rgba(87,84,229,0.6)] backdrop-blur-[5px]'>
           <div className='-mb-[30px] '>
           <Avatar avatar={photo} genre={person.personalInfo?.gender}  />
           </div>
      
        <div className=' relative'>
          <img
            onClick={closeModal}
            src={iconCloseModalRecharge}
            width={20}
            height={20}
            className=" absolute right-[24px] top-[24px]  hover:cursor-pointer"
          />
          <img src={BGModal} width={327} height={78} alt=''/>
        
        </div>
        
          <div className="flex w-[327px] rounded-b-[16px] -mt-2 flex-col items-center bg-[#FFF] ">
            
            <div className=" text-[#1D3A70] text-[20px] font-semibold ">{TransferData?.BeneficiaryName}</div>
            <div className="mt-3 text-[#666666] text-[14px] font-normal leading-3">+{TransferData?.phoneNumberBeneficiary}  </div>

            <div className='flex flex-col gap-3 m-8'>
                  { ListFunction.map((item, index)=>(
                    
                    <div
                    key={index}
                    className={`px-4 h-[60px] rounded-lg flex items-center gap-5 w-[280px] cursor-pointer  
                      ${
                        item.Enabled?.includes('all') ||
                          item.Enabled?.includes(TransferData?.valuePays ?? '')
                            ? item.color
                            : 'hidden'
                        }                       } 
                    `}
                   
                    onClick={() => {
                      if(
                         TransferData?.valuePays &&
                          (
                            item.Enabled?.includes(TransferData.valuePays) ||
                            item.Enabled?.includes('all')
                          )
                        )
                      {closeModal()
                        
                        navigate(item.navigate)
                      }
                    }}
                  >
                        <img  width={40} height={40} src={item.icon} alt={item.transaction}/>
                        <h3 className='text-[#FFFFFF] font-semibold'> {item.transaction}</h3>
                      
                    </div>

                  ))}
            </div>

            
          </div>
        
    
    </div>,
    modalRoot 
  )
}

export default ModalHomeBeneficiary
